<template>
    <v-container class = "storage-container">
        <v-expansion-panels
            v-model="panel"
            class="expansion-panel"
        >
            <v-expansion-panel>
                <v-expansion-panel-header class="card-title mt-1">
                    <div>
                        Υλικά
                        <v-icon :color="theming.cardsAndTablesText || 'black'" class="px-4" @click.stop="togglePanel()" large>
                            mdi-tune
                        </v-icon>
                        <!-- <v-col v-if="containsAny(['ROLE_ADMIN'], userRoles)" cols="6" align="end" class="create-new">
                            <v-btn class="my-2 mr-2" dark small color="black" @click="createMaterial">
                                <v-icon dark>mdi-plus</v-icon>ΔΗΜΙΟΥΡΓΙΑ
                            </v-btn>
                        </v-col> -->
                    </div>
                </v-expansion-panel-header>
                <v-divider/>
                <v-expansion-panel-content>
                    <div class="storage-filters">
                        <v-select
                            v-model="filter.client.id"
                            :items="clients"
                            item-value="id"
                            item-text="name"
                            label="Πελάτης"
                            clearable
                            outlined
                            class="filter-field client"
                            @change="onClientSelect"
                        ></v-select>
                        <v-select
                            v-model="filter.contractor.id"
                            :items="contractors"
                            item-value="id"
                            item-text="name"
                            label="Εργολάβος"
                            clearable
                            outlined
                            class="filter-field client"
                            @change="onContractorSelect"
                        ></v-select>
                        <v-text-field
                            v-model="filter.code"
                            label="Κωδικός"
                            type="text"
                            class="filter-field code"
                        />
                    </div>
                    <div class="search-button-wrapper">
                        <v-btn class="mx-2 white--text" medium color="black" @click="onSearch">
                            <v-icon medium class="bulding-id-icon">mdi-filter</v-icon> Αναζητηση
                        </v-btn>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <array-view :items="materials" :headers="headers" :totalPages="totalPages" :page="page" :size="size" @paginationChange="paginationChange" @item-clicked="onTableItemClick" class="table"/>
    </v-container>
</template>
<script>
    import material from '@/services/material'
    import ArrayView from '@/components/ArrayView.vue'
    import client from '@/services/client'
    import jwtUtil from '@/utils/jwtUtil'

    export default {
        components: { ArrayView },
        computed: {
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            currentUserId() {
                return this.$store.getters.getUserId
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            getPageFromRouteQuery() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.page && !isNaN(routeQuery.page)) {
                    return parseInt(routeQuery.page)
                }
                return 1
            },
            getSizeFromRouteQuery() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.size && !isNaN(routeQuery.size)) {
                    return parseInt(routeQuery.size)
                }
                return 5
            }
        },
        data() {
            return {
                materials: [],
                headers: [
                    {
                        text: 'ID',
                        align: 'start',
                        sortable: false,
                        value: 'id'
                    },
                    { text: 'Πελάτης', value: 'client' },
                    { text: 'Υλικό', value: 'name' },
                    { text: 'Κωδικός', value: 'code' },
                    { text: 'Σε στάδιο', align: 'center', value: 'assignmentTab' },
                    { text: 'Ποσότητα', align: 'center', value: 'totalQuantity' },
                    { text: 'Μονάδα Μέτρησης', align: 'center', value: 'materialMeasurement' }
                ],
                sizes: [5, 10, 30, 60, 100],
                page: 1,
                size: 5,
                panel: undefined,
                totalPages: 0,
                sort: null,
                clients: [],
                contractors: [],
                menu: false,
                query: {},
                filter: {
                    client: { id: null },
                    contractor: { id: null },
                    code: null
                }
            }
        },
        created() {
            this.getAllClients()
            this.getPageAndSizeFromRoute()
        },
        methods: {
            onTableItemClick(item) {
                this.$router.push(`/material/${item.id}`)
            },
            getAllClients() {
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                })
            },
            onClientSelect(clientId) {
                const selectedClient = this.clients.find(client => client.id === clientId)
                if (selectedClient) {
                    this.contractors = selectedClient.contractors
                }
            },
            onContractorSelect(contractorId) {
                this.filter.materialQuantities = [ { contractor: { id: contractorId } } ]
            },
            getMaterials() {
                material.getMaterials(this.page, this.size, this.query, this.sort).then(resp => {
                    this.materials = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            getPageAndSizeFromRoute() {
                this.page = this.getPageFromRouteQuery
                this.size = this.getSizeFromRouteQuery
                this.getMaterials()
            },
            paginationChange(page, size) {
                if (page !== this.page || size !== this.size) {
                    this.$router.push({ query: { page, size } })
                }
                this.page = page
                this.size = size
                this.getMaterials()
            },
            togglePanel() {
                const curr = this.panel
                this.panel = curr === undefined ? 0 : undefined
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            onSearch() {
                this.query = { ...this.filter }
                if (!this.query.client.id) {
                    delete this.query.client
                }
                if (!this.query.contractor.id) {
                    delete this.query.materialQuantities
                }
                delete this.query.contractor
                this.page = 1
                this.getMaterials()
            }
        }
    }
</script>
<style scoped>

.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.storage-container {
    padding-top: 3%;
}

.storage-filters {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.filter-field {
    padding: 0.8rem;
}

.filter-field.code {
    max-width: 250px;
    align-self: center;
}

.filter-field.client {
    max-width: 250px;
}
.table {
    width: 85%;
}
.expansion-panel {
    max-width: 90%;
    margin: 0 auto;
}

@media only screen and (max-width: 540px) {
    .expansion-panel {
        max-width: 100%;
    }
}
.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}
.search-button-wrapper {
    display: flex;
    justify-content: center;
}
.card-title {
    font-weight: 500;
    font-size: 1.4rem;
}

</style>
